<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="assinarPrescricaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-signature mr-2"></i>
                            Assinar {{ model }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        
                        <input 
                            type="text" 
                            id="password" 
                            style="-webkit-text-security: disc;" 
                            v-model="chave" 
                            autocomplete="off"
                            class="form form-control" />

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <az-submit @click="assinar ()">Assinar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            chave: "",
            validate: false, 
            model: null,
            id: null,
            st_tipo_especial: '', 
            callback: null, 
        }
    },

    components: { 
        AzSubmit,
    },

    methods: { 

        fechar() { 
            $('#assinarPrescricaoModal').modal('hide');
        },

        solicitar (model, id, callback, st_tipo_especial = '') { 
            this.validate = false;
            this.model = model;
            this.id = id;
            this.callback = callback;
            this.st_tipo_especial = st_tipo_especial;

            $('#assinarPrescricaoModal').modal('show');
        },

        assinar () { 

            let chave = this.chave;
            
            this.$nextTick(() => { 

                this.$util.atualizar(this, { 
                    service: 'enfermagem',
                    func: 'assinar_prescricao',
                    redir_api: true, 
                    dados: { 
                        id_receita: this.id,
                        chave: chave,
                    },
                    callback: () => { 

                        if ( process.env.VUE_APP_GTAG ) { 

                            let action = 'assinar-documento';
                            let label = this.$store.state.user.st_login + ' / ' + this.model + '-' + this.id;

                            this.$gtag.event(action, {
                                'event_category': window.redir,
                                'event_label': label,
                                'value': 1
                            });

                        }

                        let userData = this.$store.state.user;
                        userData.chave = chave;

                        this.$store.commit("setUser", userData);

                        this.callback ();
                    },
                    modal: 'assinarPrescricaoModal'
                });

            });

        },

    },

    mounted() { 
        this.chave = this.$store.state.user.chave;
    }
}
</script>